import React, { Fragment, useState } from "react";
import { Button, Card, CardBody, Col, CardFooter, Row } from "reactstrap";
import TransitionOnLoad from "Components/TransitionOnLoad";
import PageHeading from "Layout/AppMain/PageHeading";
import moment from "moment";
import ReactTableGeneric from "Components/ReactTableGeneric";
import Loader from "react-loaders";
import { DropdownList } from "react-widgets/cjs";
import { useViewLogs } from "Api/Common/LogboekInzage";
import { useCommunityContractList } from "Api/Common/LogPersoonsgegevens";

const LogboekInzage = () => {
    const [selectedCommunity, setSelectedCommunity] = useState('Alle besturen');

    const {
        data: viewLogsResponse,
        isLoading,
        mutate,
    } = useViewLogs(selectedCommunity);

    const logs = viewLogsResponse?.data || [];
     const totalCount = viewLogsResponse?.total|| [];

    const {
        data: communityResponse,
        isLoading: communityLoading,
    } = useCommunityContractList();

    const communities = [
        {
            iCommunityId: "all",
            vCommunityName: "Alle besturen",
        },
        ...(communityResponse?.communities || []),
    ];

    const columns = [
        {
            header: 'Datum-tijd',
            accessorKey: 'created_at',
            cell: ({ row }) =>
                moment(row.original.created_at).format(
                    'DD-MM-YYYY HH:mm:ss'
                ),
        },
        {
            header: ' Naam - Clooser-id',
            accessorKey: 'performed_naam_clooser_id',
        },
        {
            header: 'Organisatie',
            accessorKey: 'vCommunityName',
        },
        {
            header: "Logboek",
            accessorKey: "eLogType",
        },

    ];

    if (isLoading) {
        return (
            <Loader
                type="ball-grid-pulse"
                className="mt-3 d-flex mx-auto justify-content-center"
            />
        );
    }

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <Row>
                    <Col md="12">
                        <Card className="main-card mb-3">
                            <CardBody className="p-3">
                                <ReactTableGeneric
                                    data={logs}
                                    columns={columns}
                                    filters={{
                                        search: true,
                                        pagination: true,
                                        sorting: true,
                                    }}
                                    tableClassName="mb-0 table table-sm table-hover table-borderless color-white"
                                    count={totalCount}
                                />
                            </CardBody>

                        </Card>
                    </Col>
                </Row>
            </TransitionOnLoad>
            <div className="chat-layout-footer">
                <CardFooter className="chat-layout-footer__inner gebruikers-footer">
                    <div className="d-flex gap-3 mr-4">
                        <div className="footer-field-min-width">
                            <DropdownList
                                data={communities}
                                dataKey="iCommunityId"
                                textField="vCommunityName"
                                placeholder="Organisatie"
                                value={
                                    communities.find(
                                        c => c.vCommunityName === selectedCommunity
                                    ) || communities[0]
                                }


                                onChange={(community) =>
                                    setSelectedCommunity(community?.vCommunityName ?? "")
                                }
                                filter="contains"
                                dropUp
                            />
                        </div>
                    </div>
                </CardFooter>
            </div>
        </Fragment>

    );
};

export default LogboekInzage;